var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hotspot-form" },
    [
      _c(
        "div",
        { staticClass: "hotspot-form-container" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, "label-width": "70px" } },
            [
              _c("div", { staticClass: "upload-img" }, [
                _c("span", { staticClass: "label" }, [_vm._v("图片：")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "img", on: { click: _vm.uploadImg } },
                  [
                    _vm.form.pic
                      ? _c(
                          "div",
                          { ref: "HotImgRef", staticStyle: { width: "60px" } },
                          [
                            _c("el-image", {
                              staticStyle: { width: "100%" },
                              attrs: { src: _vm.form.pic },
                            }),
                          ],
                          1
                        )
                      : _c("i", {
                          staticClass: "el-icon-camera cameraIconfont",
                        }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "add-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.setHotspot },
                },
                [_vm._v("去设置热区")]
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("span", { staticClass: "label" }, [_vm._v("边距：")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "左侧" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.imgActPadding.pl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.imgActPadding, "pl", $$v)
                          },
                          expression: "form.imgActPadding.pl",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "顶侧" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.imgActPadding.pt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.imgActPadding, "pt", $$v)
                          },
                          expression: "form.imgActPadding.pt",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "右侧" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.imgActPadding.pr,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.imgActPadding, "pr", $$v)
                          },
                          expression: "form.imgActPadding.pr",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "底侧" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.imgActPadding.pb,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.imgActPadding, "pb", $$v)
                          },
                          expression: "form.imgActPadding.pb",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SetHotspotVue", {
        ref: "setHotspotVueRef",
        on: { updateForm: _vm.updateForm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }